/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_Eligible_Profiles_TooltipInputs */

const en_task_settings_eligible_profiles_tooltip = /** @type {(inputs: Task_Settings_Eligible_Profiles_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cognito roles whose users may be assigned this activity type. Admin assignment exceptions and customer/branch restrictions still apply.`)
};

const pt_br2_task_settings_eligible_profiles_tooltip = /** @type {(inputs: Task_Settings_Eligible_Profiles_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfis do Cognito cujos usuários podem receber este tipo de atividade. A exceção de atribuição para Administradores e as restrições de cliente/filial continuam valendo.`)
};

/**
* | output |
* | --- |
* | "Cognito roles whose users may be assigned this activity type. Admin assignment exceptions and customer/branch restrictions still apply." |
*
* @param {Task_Settings_Eligible_Profiles_TooltipInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_eligible_profiles_tooltip = /** @type {((inputs?: Task_Settings_Eligible_Profiles_TooltipInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_Eligible_Profiles_TooltipInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_eligible_profiles_tooltip(inputs)
	return pt_br2_task_settings_eligible_profiles_tooltip(inputs)
});